import CompleteSearch, { getServerSideProps } from "src/lib/pages/CompleteSearch";
import { ICommonProps } from "src/lib/server/sanity";


//#region [Other]getServerSideProps
export { getServerSideProps };
//#endregion


//#region [Component]
export default function CompleteStreamingSearch({ appData, ...rest }: ICommonProps) {
    return <CompleteSearch isStreamingOnly appData={appData} {...rest} />
}

//#endregion